import { collection, doc, getDoc, setDoc, updateDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase/config';

const SETTINGS_COLLECTION = 'settings';
const PAYMENT_SETTINGS_DOC = 'payment';

/**
 * Service for managing payment settings
 */
const paymentSettingsService = {
  /**
   * Get payment settings from Firestore
   * @returns {Promise<Object>} Payment settings object
   */
  getPaymentSettings: async () => {
    try {
      const docRef = doc(db, SETTINGS_COLLECTION, PAYMENT_SETTINGS_DOC);
      const docSnap = await getDoc(docRef);
      
      if (docSnap.exists()) {
        return docSnap.data();
      } else {
        // Return default settings if no settings document exists
        return {
          bankName: 'Not configured',
          accountName: 'Not configured',
          accountNumber: 'Not configured',
          instructions: 'Please contact the administrator for payment instructions.',
          lastUpdated: null
        };
      }
    } catch (error) {
      console.error('Error getting payment settings:', error);
      throw error;
    }
  },
  
  /**
   * Update payment settings in Firestore
   * @param {Object} settings - Payment settings object
   * @returns {Promise<void>}
   */
  updatePaymentSettings: async (settings) => {
    try {
      const docRef = doc(db, SETTINGS_COLLECTION, PAYMENT_SETTINGS_DOC);
      const docSnap = await getDoc(docRef);
      
      const updatedSettings = {
        ...settings,
        lastUpdated: serverTimestamp()
      };
      
      if (docSnap.exists()) {
        await updateDoc(docRef, updatedSettings);
      } else {
        await setDoc(docRef, updatedSettings);
      }
    } catch (error) {
      console.error('Error updating payment settings:', error);
      throw error;
    }
  }
};

export default paymentSettingsService;
